import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/logo.webp';
import aboutBgImg1 from '../../assets/aboutBgImg1.webp';
import productsBack from '../../assets/productsBack.webp';
import industryBack from '../../assets/industryBack.webp';
import contactBg from '../../assets/contactBg.webp';
import homeBackTest from '../../assets/homeBackTest.webp';

const Header = () => {
  const location = useLocation();
 
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  const getBackgroundImage = () => {
    switch (location.pathname) {
      case '/':
        return homeBackTest;
      case '/aboutus':
        return aboutBgImg1;
      case '/products':
      case '/salts':
      case '/minerals':
      case '/chemicals':
        return productsBack;
      case '/industriesWeServe':
        return industryBack;
      case '/contactus':
      case '/sitemap':
        return contactBg;
      default:
        return homeBackTest;
    }
  };

  const getHeaderText = () => {
    switch (location.pathname) {
      case '/':
        return (
          <div className="Header-Overlay-Texts">
            <h2>45+ years of <br />supplying Quality<br /> Raw Materials.</h2>
            <p>With assured Quality, Consistency <br />& On-time delivery</p>
            <Link to="/aboutus" className="Header-Explore-Btn">Explore More</Link>
          </div>
        );
      case '/aboutus':
        return (
          <div className="Header-Overlay-Texts">
            <h1>About Us</h1>
            <p>Delivering Purity and Performance<br /> in Every Product</p>
          </div>
        );

      case '/products':
        return (
          <div className="Header-Overlay-Texts">
            <h1>Our Products</h1>
            <p>Delivering Purity and Performance <br />in Every Product</p>
            <Link to="/aboutus" className="Header-Explore-Btn">Explore More</Link>
          </div>
        );
      case '/salts':
        return (
          <div className="Header-Overlay-Texts">
            <h1>Industrial Salts</h1>
            <p>High Purity Refined, Crystal & Iodised Salt</p>
            <Link to="/contactus" className="Header-Explore-Btn">Contact Us</Link>
          </div>
        );
      case '/minerals':
        return (
          <div className="Header-Overlay-Texts">
            <h1>Industrial Minerals</h1>
            <p>High Purity Mineral Raw Materials</p>
            <Link to="/contactus" className="Header-Explore-Btn">Contact Us</Link>
          </div>
        );
      case '/chemicals':
        return (
          <div className="Header-Overlay-Texts">
            <h1>Industrial Chemicals</h1>
            <p>Chemical Raw Materials & Solutions</p>
            <Link to="/contactus" className="Header-Explore-Btn">Contact Us</Link>
          </div>
        );
      case '/industriesWeServe':
        return (
          <div className="Header-Overlay-Texts">
            <h1>Industries We Serve</h1>
            <p>Empowering Industries with Salt,<br /> Minerals & Chemicals</p>
            <Link to="/aboutus" className="Header-Explore-Btn">Explore More</Link>
          </div>
        );
      case '/contactus':
        return (
          <div className="Header-Overlay-Texts">
            <h1>Contact Us</h1>
            <p>We're Here to Support Your Industry Needs</p>
            <Link to="/aboutus" className="Header-Explore-Btn">Explore More</Link>
          </div>
        );
      case '/sitemap':
        return (
          <div className="Header-Overlay-Texts">
            <h1>Website Sitemap</h1>
            <p>Explore all pages and sections of Chemi Salt Corporation</p>
          </div>
        );
      default:
        return '';
    }
  };

  return (
    <header
      className="header"
      style={{
        backgroundImage: `url(${getBackgroundImage()})`,
        transition: 'background-image 1s ease-in-out',
      }}
    >
      <div className="Header-Row-Align">
        <Link to="/">
          <img src={logo} alt="logo" className="Header-Logo-Image" />
        </Link>
        {/* Hamburger Icon */}
        <div className="hamburger" onClick={toggleDrawer}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Normal Nav */}
        <nav className="desktop-nav">
          <ul className="nav-list">
            <li><a href="/">Home</a></li>
            <li><a href="/aboutus">About</a></li>
            <li><a href="/products">Products</a></li>
            <li><a href="/industriesWeServe">Industries We Serve</a></li>
            <li><a href="/contactus">Contact</a></li>
          </ul>
        </nav>
      </div>

      {/* Side Drawer */}
      {drawerOpen && (
        <>
          <div className="backdrop" onClick={toggleDrawer}></div>
          <div className="side-drawer">
            <ul>
              <li><a href="/" onClick={toggleDrawer}>Home</a></li>
              <li><a href="/aboutus" onClick={toggleDrawer}>About</a></li>
              <li><a href="/products" onClick={toggleDrawer}>Products</a></li>
              <li><a href="/industriesWeServe" onClick={toggleDrawer}>Industries We Serve</a></li>
              <li><a href="/contactus" onClick={toggleDrawer}>Contact</a></li>
            </ul>
          </div>
        </>
      )}

      {getHeaderText()}
    </header>
  );
};

export default Header;
